import { combineReducers } from "redux";
import bikeData from "./bikeDataReducer";

export default combineReducers({
  bikeData: bikeData
});
